<template>
  <div>
    <div class="warp">
      <!-- 面包屑 -->
      <!-- <breadcrumb :back="false" :crubList="[{name:'债权融资管理'},{name:'债权融资需求列表'}]" :title="'债权融资需求列表'" /> -->
      <!-- 查询条件 -->
      <div class="retrieve border" ref="condition">
        <div class="left">
          <div class="child">
            <span class="name">上架状态</span>
            <el-select v-model="sendInfoOne.status" placeholder="请选择" size="small" clearable>
              <el-option
                v-for="item in upDown"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="child">
            <span class="name">开户行受理结果</span>
            <el-select v-model="sendInfoOne.acceptStatus" placeholder="请选择" size="small" clearable>
              <el-option
                v-for="item in bankList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="child">
            <span class="name">需求状态</span>
            <el-select v-model="sendInfoOne.demandStatus" placeholder="请选择" size="small" clearable>
              <el-option
                v-for="item in demandStatus"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="child">
            <span class="name">发布日期</span>
            <el-date-picker
              size="small"
              v-model="dateS"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :default-time="['24:00:00','23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <div class="child super_select">
            <span class="name">检索</span>
            <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
          </div>
          <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
          <el-button  size="small" @click="exportButton" class="retrievalBtn">导出</el-button>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        :data="tableData"
        @sort-change="sortChange"
         ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
        style="width: 100%"
      >
        <el-table-column prop="id" show-overflow-tooltip  label="债权需求ID"></el-table-column>
        <el-table-column prop="companyName" show-overflow-tooltip  label="企业全称"></el-table-column>
        <el-table-column prop="bankName" show-overflow-tooltip  label="开户银行"></el-table-column>
        <el-table-column
          prop="acceptStatusValue"
          show-overflow-tooltip
          
          label="开户行受理结果"
        ></el-table-column>
        <el-table-column prop="demandStatusValue" show-overflow-tooltip  label="需求状态"></el-table-column>
        <el-table-column prop="statusValue" show-overflow-tooltip  label="上架状态"></el-table-column>
        <el-table-column prop="releaseAccount" show-overflow-tooltip  label="发布账号"></el-table-column>
        <el-table-column
          prop="createTime"
          show-overflow-tooltip
          
          sortable="custom"
          width="150"
          label="发布时间"
        ></el-table-column>
        <el-table-column
          prop="approvedDate"
          show-overflow-tooltip
          
          sortable="custom"
          width="150"
          label="审核通过时间"
        ></el-table-column>
        <el-table-column
          prop="views"
          sortable="custom"
          show-overflow-tooltip
          
          label="浏览数"
        ></el-table-column>

        <el-table-column prop="recProductNum" show-overflow-tooltip  label="推荐债权产品数"></el-table-column>
        <el-table-column
          v-if="authorities.indexOf('sys:permission:background:debt:needs:list:button:view') != -1 ||
                    authorities.indexOf('sys:permission:background:debt:needs:list:button:public') != -1 ||
                    authorities.indexOf('sys:permission:background:debt:needs:list:button:dealWith') != -1 ||
                    authorities.indexOf('sys:permission:background:debt:needs:list:button:remote:product') != -1 ||
                    authorities.indexOf('sys:permission:background:debt:needs:list:button:shelves') != -1"
          label="操作"
          
          width="400"
        >
          <template slot-scope="scope">
            <el-button
              size="small" type="primary" class="super" plain 
              v-if="authorities.indexOf('sys:permission:background:debt:needs:list:button:view') != -1"
              @click="check(scope.row)"
            >查看</el-button>
            <el-button
              size="small" type="primary" class="super" plain 
              :disabled="!(scope.row.acceptStatusValue === '未反馈'&&scope.row.demandStatus === 0)"
              v-if="authorities.indexOf('sys:permission:background:debt:needs:list:button:public') != -1"
              @click="publicity(scope.row)"
            >公示</el-button>
            <el-button
              size="small" type="primary" class="super" plain 
              :disabled="scope.row.demandStatus !== 1"
              v-if="authorities.indexOf('sys:permission:background:debt:needs:list:button:dealWith') != -1"
              @click="dealWith(scope.row)"
            >处理</el-button>
            <el-button
              size="small" type="primary" class="super" plain 
              :disabled="scope.row.demandStatus !== 1"
              v-if="authorities.indexOf('sys:permission:background:debt:needs:list:button:remote:product') != -1"
              @click="products(scope.row)"
            >推荐产品</el-button>
            <el-button
              :disabled="scope.row.status == 0"
              size="small" type="primary" class="super" plain 
              v-if="authorities.indexOf('sys:permission:background:debt:needs:list:button:shelves') != -1"
              @click="soldOut(scope.row)"
            >下架</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination" ref='pagination'>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="sendInfoOne.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="需求处理结果" :visible.sync="dialogAudit" width="40%" :before-close="handleClose">
      <el-form :model="formData" ref="formData" :rules="rules" label-width="150px">
        <el-form-item label="受理结果：" prop="serviceId">
          <el-select v-model="formData.demandStatus" placeholder="请选择受理结果" @change="productChange">
            <el-option
              v-for="item in productList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.demandStatus==='2'" label="贷款银行：" prop="loanBank">
          <el-input v-model.trim="formData.loanBank" placeholder="请输入贷款银行"></el-input>
        </el-form-item>
        <el-form-item v-if="formData.demandStatus==='2'" label="放款金额（万元）：" prop="demandLoanAmount">
          <el-input v-model="formData.demandLoanAmount" placeholder="请输入放款金额"></el-input>
        </el-form-item>
        <el-form-item label="说明：" :prop="formData.demandStatus==='1'?'demandInstructions':''">
          <el-input
            type="textarea"
            v-model="formData.demandInstructions"
            :placeholder="formData.demandStatus==='1'?'贷款失败需填写说明':'请输入说明'"
            maxlength="200"
          ></el-input>
        </el-form-item>

        <el-form-item class="dialogButton">
          <el-button type="primary" size="small" @click="remarkSure">确定</el-button>
          <el-button size="small" @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import breadcrumb from "../../components/breadcrumb";
import timeMixins from "@/mixins/timeFormat";
import Regular from "@/mixins/regular.js";
export default {
  mixins: [timeMixins],
  components: {
    // breadcrumb
  },
  data() {
    var checkAge = (rule, value, callback) => {
      if (!/^[0-9]+([.]{1}[0-9]+){0,1}$/.test(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      bHeight: void 0,
      authorities: JSON.parse(window.localStorage.getItem("authorities")),
      options: [
        {
          value: "companyName",
          label: "企业名称"
        },
        {
          value: "bankName",
          label: "银行名称"
        },
        {
          value: "releaseAccount",
          label: "发布账号"
        }
      ], //检索下拉
      getSelect: "", //检索下拉的值
      getValue: "", //检索输入框的值
      dateS: [], //日期
      sendInfoOne: {
        acceptStatus: "",
        demandStatus: "",
        currentPage: 1, //当前页
        pageSize: 10, //页条数
        status: "", //上架状态
        userName: "", //发布账号
        bankName: "", //银行名称
        debtProductName: "", //债权产品名称
        startDate: null, //开始时间
        endDate: null, //结束时间
        property: null, //排序字段
        direction: null //排序方式
      }, //检索提交数据
      tableData: [], //表格数据
      currentPage: 1, //当前页
      upDown: [], //上下架
      demandStatus: [], //贷款类型,
      bankList: [], // 开户行
      totalSize: null, //总条数
      //
      dialogAudit: false,
      formData: {
        id: "",
        demandLoanAmount: null,
        demandInstructions: "",
        demandStatus: "1",
        loanBank: ""
      },
      rules: {
        loanBank: [
          { required: true, message: "请填写贷款银行", trigger: "blur" }
        ],
        demandLoanAmount: [
          { required: true, message: "请填写放款金额", trigger: "blur" },
          { validator: checkAge, trigger: "blur" }
        ],
        demandInstructions: [
          { required: true, message: "请填写说明", trigger: "blur" }
        ]
      },
      productList: [
        {
          value: "1",
          label: "贷款失败"
        },
        {
          value: "2",
          label: "贷款成功"
        }
      ]
    };
  },
  computed: {
    errors() {
      return this.$vuerify.$errors; // 错误信息会在 $vuerify.$errors 内体现
    }
  },
  watch: {
    getSelect(val, old) {
      if (val === "") {
        this.getValue = "";
      }
    }
  },
  methods: {
    doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
    productChange(val) {
      if (val === 1) {
        this.formData.demandLoanAmount = "";
        this.formData.loanBank = "";
      }
    },

    //需求处理结果 确认按钮
    remarkSure() {
      this.$refs["formData"].validate(valid => {
        if (valid) {
          this.$axiosc
            .put(
              "backstage/myDeptNeeds/dealWith",
              this.$qs.stringify(this.formData)
            )
            .then(res => {
              if (res.code == 200) {
                this.$refs["formData"].resetFields();
                this.getData();
                this.$message({
                  type: "success",
                  message: "处理成功！"
                });
                this.dialogAudit = false;
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    //需求处理 弹框
    dealWith(row) {
      this.dialogAudit = true;
      this.formData.id = row.id;
    },
    //需求处理结果 取消按钮
    handleClose: function() {
      this.$refs["formData"].resetFields();
      this.dialogAudit = false;
    },
    //查询
    retrieval: function() {},
    //获取字典
    getDic: function() {
      this.$axiosz.get("backstage/sysDict/isShow/UA_LS").then(r => {
        //上下架
        if (r.code == 200) {
          this.upDown = r.data;
        }
      });
      this.$axiosz.get("backstage/sysDict/isShow/ACCEPT_STATUS").then(r => {
        //上下架
        if (r.code == 200) {
          this.bankList = r.data;
        }
      });

      this.$axiosz.get("backstage/sysDict/isShow/DEMAND_STATUS").then(r => {
        //需求状态
        if (r.code == 200) {
          this.demandStatus = r.data;
        }
      });
    },
    //导出
    exportButton: function() {
      let obj = Object.assign({}, this.sendInfoOne);
      if (this.dateS && this.dateS.length > 0) {
        obj.startDate = this.dateS[0];
        obj.endDate = this.dateS[1];
      }
      if (this.getSelect && this.getValue) {
        obj[this.getSelect] = this.getValue;
      }
      this.$axiosc
        .get("backstage/export/myDeptNeeds", {
          params: obj
        })
        .then(res => {
          if (res.code == 200) {
            var aLink = document.createElement("a");
            var blob = this.dataURLtoBlob(res.data.bytes);
            var reader = new FileReader();
            reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
            reader.onload = function(e) {
              var a = document.createElement("a"); // 转换完成，创建一个a标签用于下载
              a.download = res.data.fileName;
              a.href = e.target.result;
              document.body.appendChild(a); // 修复firefox中无法触发click
              a.click();
              document.body.removeChild(a);
            };
          } else {
            this.$alert(res.msg);
          }
        });
    },
    dataURLtoBlob: function(dataurl) {
      let bstr = atob(dataurl), //负责解码已经使用base64编码了的字符串
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: "application/vnd.ms-excel;charset=UTF-8;"
      });
    },
    getData() {
      let obj = Object.assign({}, this.sendInfoOne);
      if (this.dateS && this.dateS.length > 0) {
        obj.startDate = this.dateS[0];
        obj.endDate = this.dateS[1];
      }
      if (this.getSelect && this.getValue) {
        obj[this.getSelect] = this.getValue;
      }
      this.loading = true
      this.$axiosc.get("backstage/myDeptNeeds", { params: obj }).then(r => {
        this.loading = false
        if (r.code == 200) {
          this.tableData = r.data.content;
          this.totalSize = r.data.totalElements;
        } else {
          this.$alert(r.msg);
        }
      }).catch(e=>{
        this.loading = false
      })
    },
    //表格排序
    sortChange: function({ column, prop, order }) {
      let ord = "";
      if (order == "ascending") {
        ord = "asc";
      } else {
        ord = "desc";
      }
      this.sendInfoOne.property = prop;
      this.sendInfoOne.direction = ord;
      this.getData();
    },
    // 推荐产品
    products(row) {
      this.$router.push({
        path: "/debtManagement/productDemandRecommend",
        query: { id: row.id, index: "/debtManagement/productDemandList" }
      });
    },
    //表格查看按钮
    check: function(row) {
      this.$router.push({
        path: "/debtManagement/productDemandDetail",
        query: { id: row.id, index: "/debtManagement/productDemandList" }
      });
    },
    // 公示
    publicity(row) {
      this.$confirm("公示后，开户行不可再操作，确认公示？", "公示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axiosc
            .put("backstage/myDeptNeeds/publicity/" + row.id)
            .then(res => {
              if (res.code == 200) {
                this.getData();
                this.$message({
                  type: "success",
                  message: "公示成功!"
                });
              } else {
                this.$alert(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    //表格下架按钮
    soldOut: function(row) {
      this.$confirm("下架后不可重新上架，确认下架？", "下架", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axiosc
            .put("/backstage/myDeptNeeds/status/" + row.id)
            .then(res => {
              if (res.code == 200) {
                this.getData();
                this.$message({
                  type: "success",
                  message: "下架成功!"
                });
              } else {
                this.$alert(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    //分页功能模块
    //切换每页显示条数
    handleSizeChange(val) {
      this.sendInfoOne.pageSize = val;
      this.getData();
    },
    //切换页码
    handleCurrentChange(val) {
      this.sendInfoOne.currentPage = val;
      this.getData();
    }
  },
  mounted() {
    const that = this
    that.getDic();
    that.getData();
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  }
};
</script>